import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HasWrongEmailComponent} from './has-wrong-email.component';



const routes: Routes = [
  {
    path: '',
    component: HasWrongEmailComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HasWrongEmailRoutingModule { }
